import React, {memo, useRef, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay,FreeMode,Navigation,Thumbs } from 'swiper';
import {useSelector} from 'react-redux';
import SrollAnimtion from '../SrollAnimtion';
import { eventRun, backTo, getOuterHeight } from '../../utils';

import 'swiper/css';
import styles from './styles.module.scss';

import btnNext from '../../assets/img/home/one/btn_next.svg';
import btnNextHover from '../../assets/img/home/one/btn_nextHover.svg';



// install Swiper modules
SwiperCore.use([Autoplay, FreeMode, Navigation, Thumbs]);

const Index = memo(() => {
  const globalConfig = window.globalConfig;
  const {value, screenHeight} = useSelector(({recReSizeReducer}) => recReSizeReducer);
  const { home:{ videoDisplayData } } = useSelector(({localesReducer}) => localesReducer.i18n);

  const videoRef = useRef();

   // 获取 History
   let location = useLocation();
   let navigate = useNavigate();

  const [btnNextFlag, setBtnNextFlag] = useState(false);


  // 样式判断
  const normal = () => {
    if(value > 1920){
      return styles.normalXl2;
    }

    if(value > 1440 && value <= 1920){
      return styles.normalXl;
    }

    if(value > 1024 && value <= 1440){
      return styles.normalLg;
    }

    if(value > 750 && value <= 1024){
      return styles.normalMd;
    }

    if(value <= 750){
      return styles.normalSm;
    }
  };



  const handleJump = () => {
    navigate('/aboutus');
    backTo();
  }



  const videoElement = () => {
    const { videoSource } = globalConfig;
    const heightVal = screenHeight || document.documentElement.clientHeight;

    const videoCss = value <= 750 ? {
      height: '100vh',
      objectFit: 'cover',
    } : {
      width: value,
      height: heightVal,
      objectFit: 'cover',
    }

    return (
      <video 
        className="background" 
        ref={videoRef}
        autoPlay
        playsInline
        loop
        muted
        style={videoCss}
      >
        <source src={videoSource} type="video/mp4" />
      </video>
    );
  }

  
  useEffect(() => {
    // 事件触发行为
    eventRun({
      currentEle: videoRef,               // 当前的元素-必传
      eventMethod: 'videoClick',          // 自定义事件-必传
      data: {name: 'Hello Video !!!!!!'}, // 数据-可选参数
      callback: ({ele, message }) => {    // 回调函数
          ele.current.play();
          ele.current.muted = true;

          // animation();
      },
    });
    
  }, []);
  

  const bannerContentsRen = (item) => {

    const isTitle = value <= 750 ? item.titlem : item.titlep
    return (
      <div className="bannerContents">
        <div className="title">
          <img src={isTitle} alt=""/>
        </div>
        <div className="titleSub"><span>{item.desc}</span></div>
        <div className="btn" onClick={handleJump} style={{cursor: 'pointer'}}>
          {/* <img src={btnNext} alt=""/> */}
          <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="104" height="104" rx="52" fill="white" fillOpacity="0.05"/>
            <path d="M59.9472 62L68.9471 53L59.9472 44" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M67.88 52.9999L38 52.9999" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle opacity="0.8" cx="53" cy="53" r="44.5" stroke="white"/>
            <rect x="1" y="1" width="104" height="104" rx="52" stroke="white" strokeWidth="2"/>
          </svg>
        </div>
      </div>
    );

  }

  const svgTitlePCH5 = () => {
     return value <= 750 ? (
      <svg width="650" height="139" viewBox="0 0 650 139" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g style={{mixBlendMode: 'lighten'}}>
          <path fillRule="evenodd" clipRule="evenodd" d="M441.987 55.4862C445.547 55.5187 446.523 53.7141 446.815 51.3568C447.27 47.8453 444.881 45.618 440.816 43.4883C438.784 42.4153 434.2 45.5042 435.37 49.4385C435.289 51.5844 438.963 55.4537 441.987 55.4862ZM642.488 67.5166C642.488 67.5166 641.854 67.9555 637.968 70.8168C638.505 69.7926 639.009 68.7521 639.562 67.7279C640.472 66.0046 635.318 59.7944 631.677 60.2171C630.132 60.3959 627.645 63.2572 627.645 63.2572C627.645 63.2572 620.914 53.4215 604.803 59.9895C585.474 67.858 574.532 82.8797 575.719 77.1409C576.077 63.1434 571.671 60.087 566.729 60.087C556.34 60.1032 540.571 72.6701 540.571 72.6701C540.571 72.6701 542.831 65.7933 544.148 62.8995C545.009 60.9974 535.629 54.9822 535.629 54.9822C535.629 54.9822 518.136 82.7009 515.047 72.1336C513.681 64.0213 510.154 63.0133 506.187 62.0541C506.219 62.1029 506.187 62.1029 506.106 62.0379C506.138 62.0379 506.154 62.0541 506.187 62.0541C506.008 61.7452 503.033 58.8514 500.432 57.3883C471.981 41.4724 449.693 79.4007 437.906 79.547C433.777 79.5957 437.89 70.069 441.808 63.0133C443.206 60.5097 433.939 52.5924 432.785 55.7138C429.696 64.1351 425.502 70.9306 420.706 74.6698C414.382 79.5957 408.107 76.0354 408.253 74.0683C407.619 71.5972 415.536 66.8013 420.966 63.2572C427.664 58.9002 419.535 52.82 413 56.0064C406.546 59.1603 402.53 63.4522 396.824 67.8092C394.158 64.5252 389.573 59.3229 387.866 57.2582C385.964 55.031 384.599 54.527 382.778 57.0144C381.396 58.9165 378.063 62.2329 378.063 62.2329C378.063 62.2329 377.364 57.6972 373.202 57.6972C370.764 57.6972 368.504 62.2492 368.504 62.2492C368.504 62.2492 358.164 43.2119 332.331 66.9151C331.584 65.777 329.763 64.9967 328.543 66.281C297.281 98.7631 320.464 48.4305 287.266 64.2326C279.495 67.923 276.211 70.4754 278.227 66.8825C278.764 65.9234 281.934 64.0213 278.78 60.8999C277.3 59.4367 276.13 58.5751 274.813 57.4371C272.114 55.0797 269.123 60.3634 267.416 62.4443C249.143 84.9607 249.858 70.2641 249.858 70.2641C249.793 67.289 250.703 61.6477 242.656 61.5827C243.534 62.233 236.641 57.7622 235.47 57.3883C203.232 46.8861 196.177 72.41 181.464 77.1571C182.715 47.9916 158.46 63.1109 156.59 64.4927C161.971 50.3001 172.262 22.4676 176.343 11.1688C177.643 7.57594 178.895 6.64927 175.855 5.08857C174.359 4.32448 172.425 3.33279 170.945 2.56869C167.97 1.04051 168.165 3.23524 166.068 8.38881C160.736 21.4434 150.185 50.1863 144.332 65.6307C121.637 85.0419 96.9908 100.893 66.606 103.949C53.0799 105.315 10.0793 105.868 47.1134 59.1929C74.0843 72.1337 131.684 72.1824 149.599 36.9366C175.01 -13.0546 118.126 0.00878173 101.901 6.97442C85.6754 13.9401 69.3209 23.0204 55.9249 34.1729C50.9177 38.3347 45.6015 43.0981 40.7406 48.3492C21.3782 40.6758 8.95758 25.1663 5.7549 20.972C4.77946 19.6876 4.09665 18.5821 3.13747 19.395C2.37338 20.029 1.17036 21.0532 0.390012 21.7198C-0.634197 22.5814 0.536311 23.4918 1.82064 25.0688C5.39724 29.507 17.6227 43.7972 35.8797 53.7792C2.95864 97.0073 43.6669 120.402 78.9615 112.972C109.541 106.534 135.96 87.9682 135.96 87.9682C135.96 87.9682 135 90.8295 134.594 93.3494C134.48 94.0485 133.391 99.2183 136.984 99.3646C138.398 99.4134 141.828 99.3321 143.194 99.3483C146.38 99.3971 149.112 89.1063 149.681 87.2854C152.168 79.1243 157.777 69.8414 166.556 69.9714C172.603 70.069 170.392 76.6532 170.978 79.1405C173.368 95.1865 194.356 82.4733 194.356 82.4733C194.356 82.4733 211.019 96.4871 242.396 76.3118C247.485 88.4885 259.97 83.6926 259.97 83.6926C259.97 83.6926 261.173 95.9668 269.838 89.8216C293.151 73.2879 301.898 67.1589 302.353 73.4667C296.029 95.219 321.699 86.4726 328.82 81.1564C328.836 81.2377 337.176 90.3581 349.467 86.8302C353.254 85.741 360.196 82.5871 360.196 82.5871C360.196 82.5871 345.646 99.6572 341.972 108.274C334.835 124.986 347.142 144.739 350.263 136.22C372.178 76.4419 378.502 76.3443 385.411 70.9956C391.784 70.7518 384.127 78.3439 379.526 81.8555C376.063 85.0257 383.493 93.9184 386.094 91.6587C388.435 89.8866 397.669 82.5058 399.994 80.7338C407.781 85.9198 413.699 90.5694 428.054 84.1153C441.58 97.43 456.618 82.3595 456.618 82.3595C456.618 82.3595 471.77 101.868 506.512 76.3443C512.592 91.0246 521.534 81.0752 523.533 85.0907C532.003 102.193 557.804 65.7283 564.437 72.1499C568.062 76.7345 566.29 87.1066 573.98 87.2204C584.384 87.3667 589.083 82.4408 589.083 82.4408C589.083 82.4408 596.886 92.0326 608.705 88.6348C612.509 87.5456 617.11 84.3429 620.508 82.5871C620.313 83.0098 605.242 103.104 601.081 109.33C593.261 121.003 605.714 150.104 611.258 133.798C625.19 92.7642 624.247 96.6822 647.381 78.1163C654.616 72.2149 644.813 66.4598 642.488 67.5166ZM135.391 11.4614C156.541 10.9575 141.194 33.2137 131.277 41.5212C96.4218 70.6868 51.8118 54.0393 51.8118 54.0393C51.8118 54.0393 91.8698 12.5182 135.391 11.4614ZM201.623 78.7016C202.045 77.9538 212.288 56.4616 237.405 65.5007C230.008 71.4021 211.263 80.0022 201.623 78.7016ZM338.981 78.1976C341.37 72.1662 348.085 67.988 354.051 66.6062C364.472 64.1838 362.895 65.9071 363.415 66.785C357.14 71.8735 348.085 76.9296 338.981 78.1976ZM465.739 78.7016C466.096 77.97 475.607 56.2828 498.318 66.9963C486.434 77.2222 480.305 81.4979 465.739 78.7016ZM598.122 79.2218C603.779 64.9967 621.402 64.509 621.581 66.4924C623.402 74.1008 597.439 79.3194 598.122 79.2218Z" fill="url(#paint0_linear_1543_5091)"/>
        </g>
        <defs>
        <linearGradient id="paint0_linear_1543_5091" x1="325" y1="2.09142" x2="325" y2="138.645" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white"/>
        </linearGradient>
        </defs>
      </svg>
     ) : (
      <svg width="1433" height="324" viewBox="0 0 1433 324" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M969.017 131.688C976.71 131.759 978.817 127.859 979.45 122.766C980.433 115.178 975.27 110.366 966.488 105.764C962.097 103.446 952.191 110.12 954.72 118.621C954.544 123.258 962.483 131.618 969.017 131.688ZM1402.25 157.683C1402.25 157.683 1400.88 158.631 1392.48 164.814C1393.64 162.601 1394.73 160.352 1395.92 158.139C1397.89 154.416 1386.75 140.997 1378.89 141.91C1375.55 142.297 1370.17 148.479 1370.17 148.479C1370.17 148.479 1355.63 127.227 1320.82 141.419C1279.05 158.42 1255.41 190.878 1257.98 178.478C1258.75 148.233 1249.23 141.629 1238.55 141.629C1216.1 141.665 1182.03 168.818 1182.03 168.818C1182.03 168.818 1186.91 153.959 1189.76 147.706C1191.62 143.597 1171.35 130.599 1171.35 130.599C1171.35 130.599 1133.55 190.492 1126.88 167.659C1123.93 150.13 1116.31 147.952 1107.74 145.88C1107.81 145.985 1107.74 145.985 1107.56 145.845C1107.63 145.845 1107.67 145.88 1107.74 145.88C1107.35 145.212 1100.92 138.96 1095.3 135.798C1033.83 101.408 985.667 183.361 960.2 183.677C951.277 183.783 960.165 163.198 968.63 147.952C971.651 142.543 951.629 125.436 949.135 132.18C942.46 150.376 933.397 165.06 923.035 173.139C909.37 183.783 895.811 176.09 896.127 171.839C894.757 166.5 911.864 156.137 923.597 148.479C938.069 139.065 920.505 125.927 906.384 132.812C892.438 139.627 883.762 148.901 871.432 158.315C865.671 151.219 855.765 139.978 852.077 135.517C847.967 130.705 845.016 129.616 841.082 134.99C838.096 139.1 830.895 146.266 830.895 146.266C830.895 146.266 829.384 136.466 820.392 136.466C815.123 136.466 810.24 146.301 810.24 146.301C810.24 146.301 787.899 105.167 732.081 156.383C730.465 153.924 726.531 152.238 723.896 155.013C656.345 225.198 706.437 116.443 634.707 150.587C617.916 158.561 610.82 164.076 615.176 156.313C616.335 154.24 623.185 150.13 616.37 143.386C613.174 140.224 610.644 138.363 607.799 135.904C601.968 130.81 595.504 142.227 591.816 146.723C552.332 195.375 553.878 163.619 553.878 163.619C553.737 157.191 555.705 145.002 538.316 144.861C540.213 146.266 525.319 136.606 522.79 135.798C453.132 113.106 437.886 168.256 406.096 178.513C408.801 115.494 356.39 148.163 352.351 151.149C363.978 120.483 386.214 60.344 395.031 35.9302C397.841 28.167 400.546 26.1647 393.977 22.7925C390.745 21.1415 386.565 18.9987 383.368 17.3477C376.94 14.0457 377.361 18.7879 372.83 29.9234C361.308 58.1309 338.51 120.237 325.864 153.608C276.826 195.55 223.573 229.8 157.919 236.404C128.693 239.355 35.7801 240.549 115.801 139.697C174.078 167.659 298.535 167.764 337.246 91.6076C392.15 -16.41 269.239 11.8164 234.181 26.8673C199.123 41.9182 163.785 61.5383 134.84 85.6359C124.021 94.6286 112.534 104.921 102.031 116.267C60.1938 99.687 33.3563 66.1752 26.4361 57.1122C24.3285 54.3371 22.8531 51.9485 20.7806 53.7049C19.1296 55.0748 16.5302 57.2879 14.844 58.7281C12.631 60.5899 15.1601 62.557 17.9352 65.9644C25.6633 75.5543 52.0793 106.431 91.5277 128C20.3942 221.404 108.354 271.953 184.616 255.9C250.691 241.989 307.774 201.873 307.774 201.873C307.774 201.873 305.701 208.056 304.823 213.501C304.577 215.011 302.223 226.182 309.987 226.498C313.043 226.603 320.455 226.428 323.405 226.463C330.29 226.568 336.192 204.332 337.421 200.398C342.796 182.764 354.915 162.706 373.884 162.987C386.951 163.198 382.174 177.424 383.439 182.799C388.602 217.47 433.952 190 433.952 190C433.952 190 469.958 220.28 537.754 176.687C548.749 202.997 575.727 192.635 575.727 192.635C575.727 192.635 578.327 219.156 597.05 205.878C647.423 170.153 666.322 156.91 667.305 170.539C653.641 217.54 709.107 198.642 724.493 187.155C724.528 187.33 742.549 207.037 769.105 199.414C777.29 197.061 792.29 190.246 792.29 190.246C792.29 190.246 760.85 227.13 752.911 245.748C737.49 281.859 764.082 324.539 770.827 306.132C818.179 176.968 831.843 176.757 846.773 165.2C860.543 164.673 843.997 181.078 834.056 188.665C826.574 195.515 842.627 214.73 848.248 209.847C853.306 206.018 873.259 190.07 878.282 186.242C895.108 197.447 907.895 207.494 938.912 193.548C968.139 222.318 1000.63 189.754 1000.63 189.754C1000.63 189.754 1033.37 231.907 1108.44 176.757C1121.58 208.477 1140.9 186.979 1145.22 195.656C1163.52 232.61 1219.27 153.819 1233.6 167.694C1241.43 177.6 1237.6 200.012 1254.22 200.257C1276.7 200.574 1286.85 189.93 1286.85 189.93C1286.85 189.93 1303.71 210.655 1329.25 203.314C1337.47 200.96 1347.41 194.04 1354.75 190.246C1354.33 191.159 1321.77 234.577 1312.78 248.031C1295.88 273.253 1322.79 336.131 1334.77 300.898C1364.87 212.236 1362.83 220.702 1412.82 180.586C1428.45 167.835 1407.27 155.399 1402.25 157.683ZM306.544 36.5625C352.245 35.4736 319.085 83.5633 297.657 101.514C222.343 164.533 125.953 128.562 125.953 128.562C125.953 128.562 212.507 38.8458 306.544 36.5625ZM449.654 181.851C450.568 180.235 472.698 133.796 526.97 153.327C510.987 166.078 470.485 184.661 449.654 181.851ZM746.448 180.762C751.612 167.729 766.119 158.701 779.011 155.716C801.528 150.482 798.121 154.205 799.245 156.102C785.686 167.097 766.119 178.022 746.448 180.762ZM1020.34 181.851C1021.11 180.27 1041.66 133.409 1090.73 156.559C1065.06 178.654 1051.81 187.893 1020.34 181.851ZM1306.38 182.975C1318.61 152.238 1356.69 151.184 1357.07 155.47C1361.01 171.909 1304.91 183.185 1306.38 182.975Z" fill="url(#paint0_linear_2935_13633)"/>
        <defs>
          <linearGradient id="paint0_linear_2935_13633" x1="716.239" y1="16.3164" x2="716.239" y2="311.372" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white"/>
          </linearGradient>
        </defs>
      </svg>

     )
  }


  const bannerContentsRenNew = (item) => {
    const isTitle = value <= 750 ? item.titlem : item.titlep
    return (
      <div className="bannerContents">
        <div className="title">
          <img src={isTitle} alt=""/>
          {/* {svgTitlePCH5()} */}
        </div>
        <div className="titleSub"><span>{item.desc}</span></div>
        <div 
          className="btn" 
          onClick={handleJump}
          onMouseMove={handleHover}
          onMouseLeave={handleHover}
          style={{cursor: 'pointer'}}
        >
           <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="104" height="104" rx="52" fill="white" fillOpacity="0.05"/>
            <path d="M59.9472 62L68.9471 53L59.9472 44" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M67.88 52.9999L38 52.9999" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle style={{transition: `all 0.5s linear 0s`, opacity: btnNextFlag ? 1 : 0}} opacity="0.8" cx="53" cy="53" r="44.5" stroke="white"/>
            <rect x="1" y="1" width="104" height="104" rx="52" stroke="white" strokeWidth="2"/>
          </svg>
        </div>
      </div>
    );

  }

  const handleHover = (event) => {
    if(event.type === 'mousemove'){
      setBtnNextFlag(true);
    }else{
      setBtnNextFlag(false);
    }
  }

  const swiperTemp = () => {
    return (
        <>
          <Swiper
              style={{
                '--swiper-navigation-color': '#fff',
                '--swiper-pagination-color': '#fff'
              }}
              spaceBetween={0}
              className="swiper swiperMain"
          >
            {videoDisplayData.map(item => {
              return (
                <SwiperSlide key={item.id} style={{background: `url(${item.img}) no-repeat 100% 100%/cover`}} >
                  {/* {bannerContentsRen(item)} */}
                  {bannerContentsRenNew(item)}
                  {videoElement()}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </>
    )
  };


  // 判断是：桌面/移动端
  const desktopMobile = () => {
    return swiperTemp();
  };


  return (
      <div className={normal()} style={{height: getOuterHeight(), overflow: 'hidden'}}>
        <SrollAnimtion />
        {desktopMobile()}
      </div>
  );
});
export default Index;
